/**
 * When adding a new constant, please ensure it follows this format:
 * export const VARIABLE_NAME = process.env.VARIABLE_NAME || ENV_VARIABLE_NAME
 *
 * process.env.VARIABLE_NAME is defined by your local .env file
 * ENV_VARIABLE_NAME is defined within your deployed environment
 */
export const UNSPLASH_ACCESS_KEY =
  process.env.UNSPLASH_ACCESS_KEY || ENV_UNSPLASH_ACCESS_KEY;
export const API = process.env.API || ENV_API;
export const DEFAULT_SCHOOL_LOGO =
  process.env.DEFAULT_SCHOOL_LOGO || ENV_DEFAULT_SCHOOL_LOGO;
export const DEFAULT_STUDENT_LOGO =
  process.env.DEFAULT_STUDENT_LOGO || ENV_DEFAULT_STUDENT_LOGO;
export const DEFAULT_EMPLOYER_LOGO =
  process.env.DEFAULT_EMPLOYER_LOGO || ENV_DEFAULT_EMPLOYER_LOGO;
export const SUPPORT_URL = process.env.SUPPORT_URL || ENV_SUPPORT_URL;
export const REACT_APP_GA_TRACKING_ID =
  process.env.REACT_APP_GA_TRACKING_ID || ENV_REACT_APP_GA_TRACKING_ID;
export const GMAP_API_KEY = process.env.GMAP_API_KEY || ENV_GMAP_API_KEY;
export const PIPE_ACCESS_KEY =
  process.env.PIPE_ACCESS_KEY || ENV_PIPE_ACCESS_KEY;
export const PIPE_EID = process.env.PIPE_EID || ENV_PIPE_EID;
export const APM_SERVER_URL =
  process.env.ENV_APM_SERVER_URL || ENV_APM_SERVER_URL;
export const DEBUG_I18N = process.env.DEBUG_I18N || ENV_DEBUG_I18N;
